import {ConfEnv} from "@/config/config";
import {useAppConfig} from "@/store/useAppConfig.store";
import {useAuthStore} from "@/store/useAuth.store";

const parseAllowlist = raw =>
  String(raw || "")
    .split(",")
    .map(entry => entry.trim().toLowerCase())
    .filter(Boolean);

const resolveGamanzaUiEnabled = (gamanzaEnabled, email) => {
  if (!ConfEnv.GAMANZA.ENABLED) return false;

  const allowlist = parseAllowlist(ConfEnv.GAMANZA.UI_ALLOWLIST);
  if (allowlist.length > 0) {
    return Boolean(email && allowlist.includes(String(email).toLowerCase()));
  }

  return Boolean(gamanzaEnabled);
};

/**
 * Runtime Gamanza UI gate.
 * - Kill-switch: VITE_GAMANZA_ENABLED
 * - If VITE_GAMANZA_UI_ALLOWLIST is set: only those emails (prod tester).
 * - Otherwise: back-office feature flag gamanza_enabled.
 * Safe to call from services (Zustand getState).
 */
export const isGamanzaUiEnabled = () => {
  const gamanzaEnabled = useAppConfig.getState().featureFlags?.gamanzaEnabled;
  const email = useAuthStore.getState().user?.email;
  return resolveGamanzaUiEnabled(gamanzaEnabled, email);
};

/** React hook for components that should re-render when the BO flag or user changes. */
export const useIsGamanzaUiEnabled = () => {
  const gamanzaEnabled = useAppConfig(state => state.featureFlags.gamanzaEnabled);
  const email = useAuthStore(state => state.user?.email);
  return resolveGamanzaUiEnabled(gamanzaEnabled, email);
};
